let lenisInstance = null;
let lockCount = 0;
let scrollPosition = 0;

export const setLenisInstance = (instance) => {
  lenisInstance = instance;
};

export const scrollToTop = (immediate = true) => {
  const behavior = immediate ? 'auto' : 'smooth';

  if (lenisInstance) {
    lenisInstance.scrollTo(0, { immediate });
  }

  window.scrollTo({ top: 0, left: 0, behavior });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

/** Run scroll reset across frames to beat mobile menu close + browser restoration. */
export const flushScrollToTop = () => {
  scrollToTop(true);
  requestAnimationFrame(() => scrollToTop(true));
  setTimeout(() => scrollToTop(true), 0);
  setTimeout(() => scrollToTop(true), 100);
};

export const lockScroll = () => {
  lockCount += 1;
  if (lockCount > 1) return;

  scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
  lenisInstance?.stop();
};

export const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  window.scrollTo(0, scrollPosition);
  lenisInstance?.start();
};
